import React, { useEffect, useState } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { categoriesApi } from '../services/api';
import Explorar from '../pages/Explorar';

/**
 * Wrapper que checa se a categoria acessada é v1 arquivada com sucessora
 * v2 configurada. Se for, faz Navigate replace pra URL nova (301 client-side).
 * Caso contrário, renderiza Explorar normalmente.
 *
 * Também trata slugs antigos que foram renomeados pra `{slug}-v1` durante o
 * import (matching via `slug_original_v1`).
 */
export default function CategoryRedirectWrapper() {
  const { municipioSlug, categoriaSlug } = useParams();
  const [state, setState] = useState({ status: 'loading', to: null });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const cats = await categoriesApi.list();
        const direct = cats.find(c => c.id === categoriaSlug || c.slug === categoriaSlug);
        if (direct?.redirect_to_v2 && direct.redirect_to_v2 !== categoriaSlug) {
          if (!cancelled) setState({ status: 'redirect', to: `/${municipioSlug}/${direct.redirect_to_v2}` });
          return;
        }
        if (!direct) {
          const legacy = cats.find(c => c.slug_original_v1 === categoriaSlug);
          if (legacy?.slug && legacy.slug !== categoriaSlug) {
            if (!cancelled) setState({ status: 'redirect', to: `/${municipioSlug}/${legacy.slug}` });
            return;
          }
        }
        if (!cancelled) setState({ status: 'ok', to: null });
      } catch {
        if (!cancelled) setState({ status: 'ok', to: null });
      }
    })();
    return () => { cancelled = true; };
  }, [municipioSlug, categoriaSlug]);

  if (state.status === 'loading') {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="category-redirect-loading">
        <div className="w-8 h-8 border-2 border-[var(--primary)] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (state.status === 'redirect' && state.to) {
    return <Navigate to={state.to} replace data-testid="category-redirect-v1-to-v2" />;
  }
  return <Explorar />;
}
